<template>
<div class="shortmessagelist"  >
    <div class="top"> 
        <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
    </div>
     <el-table stripe :data="dataList"  :height="`${windowHeight-210}px`" border style="width: 100%">
             <el-table-column  label="购买量（次）" show-overflow-tooltip align="center" >
                <template slot-scope="scope">
                    {{scope.row.count?scope.row.count:0}}                   
                </template>
            </el-table-column>  
             <el-table-column label="原价（元）" align="center">
                <template slot-scope="scope">
                      ￥ {{scope.row.money?scope.row.money/100:0}}
                </template>
            </el-table-column> 
            <el-table-column label="支付金额（元）" align="center">
                <template slot-scope="scope">
                       ￥ {{scope.row.realMoney?scope.row.realMoney/100:0}}
                </template>
            </el-table-column>   
            <el-table-column label="操作人" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.createName}}
                </template>
            </el-table-column> 
            <el-table-column label="备注" align="center">
                <template slot-scope="scope">
                         {{scope.row.remark||scope.row.auditContent||'----'}}
                </template>
            </el-table-column> 
            <el-table-column label="审批人" align="center">
                <template slot-scope="scope">
                        {{scope.row.auditName?scope.row.auditName:"----"}}
                </template>
            </el-table-column> 
            <el-table-column label="时间" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{(scope.row.state==2||scope.row.state==3)?scope.row.auditDate.substring(0, 19):scope.row.createDate.substring(0, 19)}}
                </template>
            </el-table-column> 
            <el-table-column label="支付方式" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">客服充值</span>
                     <span v-if="scope.row.type==2">在线充值</span>                     
                    <image-previewer tag="richtext" v-if="scope.row.type==3">
                          <img class="picimg" :src="scope.row.picJson" alt="" v-if="scope.row.type==3">
                    </image-previewer>
                </template>
            </el-table-column> 
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">                      
                       <el-tag v-if="scope.row.state==3" type="danger"  size="mini">被驳回</el-tag>
                       <el-tag v-else-if="scope.row.state==1" type="info"  size="mini">草稿</el-tag>
                       <el-tag v-else-if="scope.row.state==2" size="mini">同意</el-tag>
                       <el-tag v-else-if="scope.row.state==4" type="success"  size="mini">已充值</el-tag>
                </template>
            </el-table-column>
              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="deleteOcrPayRecordByIds(scope.row.id)"  :disabled="!(scope.row.state==1||scope.row.state==3)"  type="text" size="small">删除</el-button>
                         <el-button :disabled="!(scope.row.state==1&&scope.row.type==3)"  @click.native.prevent="isShowBatchAddCharfun(scope.row)"  type="text" size="small">审批确认</el-button>
                    </template>
            </el-table-column> 
        </el-table> 
          <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
        <el-dialog title="审批确认" :visible.sync="isShowBatchAddChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
                    <el-form-item label="购买次数" prop="count">
                         <el-input-number v-model="form.count" :precision="0" :step="1" :min="1" :max="1000000" placeholder="请输入购买次数" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="原价" >
                         {{(form.count*form.price)/100}}
                    </el-form-item>
                     <el-form-item label="支付金额" prop="realMoney">
                         <el-input-number v-model="form.realMoney" :precision="1" :step="0.1" :min="0.1" :max="100000" placeholder="请输入支付金额" ></el-input-number>
                    </el-form-item>

                    <el-form-item label="备注" prop="auditContent">
                        <el-input placeholder="请输入备注" type="textarea" :maxlength="500" :rows="5" v-model.trim="form.auditContent"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowBatchAddChar = false">取 消</el-button>
                 <el-button size="medium" type="primary" @click="auditOfflineRecharges(3)">不同意</el-button>
                <el-button size="medium" type="primary" @click="auditOfflineRecharges(2)">同意</el-button>
            </span>
        </el-dialog>
</div> 
</template>
<script>
import {querySchoolOcrPayRecord,deleteOcrPayRecordById,auditOfflineRecharge} from "@/api/Identificationmanagement";
import mixin from "@/mixins/windowResize";
import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
export default {
  data() {
    return {
     schoolId:this.$route.query.schoolId, 
     schoolName: this.$route.query.schoolName,
     dataList:[],
     isShowBatchAddChar:false,
     form:{
         id:"",
         auditContent:"",
         state:2,
         count:1,
         realMoney:0.1,
         money:0,
         price:''
     },
     formRules:{
         auditContent:[{ required: true, message: '请输入备注', trigger: 'blur' }],
         count:[{ required: true, message: '请输入购买次数', trigger: 'change' }],
         realMoney:[{ required: true, message: '请输入支付金额', trigger: 'change' }]
     },
      listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    schoolId: this.$route.query.schoolId,
                },
     total: null    
    };
  },
  components: {ImagePreviewer},
  mixins: [mixin],
  created() {
      this.querySchoolOcrPayRecords();
  },
  methods: {  
      isShowBatchAddCharfun(obj){
        this.form.id=obj.id;
        this.form.price=obj.price
        this.isShowBatchAddChar=true;
      },
      auditOfflineRecharges(num){   
          let myform={
              auditContent:this.form.auditContent,//审核内容	string	
                count:this.form.count,//	ocr充值次数	number	
                id:this.form.id,//	主键	number	
                money:Math.floor(this.form.count*this.form.price),//	总价(分)	number	
                price:Math.floor(this.form.price),//	单价(分)	number	
                realMoney:Math.floor(this.form.realMoney*100),//	实际支付金额(分)	number	
                state:num,//	状态 1:草稿 2:同意 3:驳回 4:支付成功 5:支付失败	number	
          }
          this.$refs.form.validate(isValid => {
                    if(isValid) {
                        auditOfflineRecharge(myform).then(res => {
                            this.$message({
                                type: 'success',
                                message: '审批核成功!'
                            });
                            this.querySchoolOcrPayRecords();
                            this.form.count=1;
                            this.form.auditContent="";
                            this.form.realMoney=0.1;
                            this.isShowBatchAddChar=false;
                        }).catch();
                    }
                })
          
      },
      querySchoolOcrPayRecords(){
          querySchoolOcrPayRecord(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                         this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
      },
      //删除
      deleteOcrPayRecordByIds(id){
          this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteOcrPayRecordById(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.querySchoolOcrPayRecords();
                    }).catch();

                }).catch(() => {
                });
      },
         //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.querySchoolOcrPayRecords();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.querySchoolOcrPayRecords();
            },
        
  }
};
</script>
<style lang="scss" scoped>
.shortmessagelist {
   padding: 12px;
  .top {
    padding-bottom: 10px;
    overflow: hidden;
  }
  .picimg{
      height: 28px;
      max-width:50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Identificationmanagement/Identificationmanagementschool.vue